export default __webpack_public_path__ + "maps-examples-camera-animators-thumbnail-480-58a8b0de66931a8815d9ad4d0e256dc4.webp";